import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import { Role } from 'dashboard/models/role';
import { User } from 'dashboard/models/user';
import { CurrentUserSessionMeta, UserSession } from 'dashboard/models/user-session';
import { fetchDashboardData } from 'dashboard/redux/thunk-actions/dashboard';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiModel } from 'lib/interfaces/api';
import { resetState } from 'lib/redux/decorators/withResetState';

export const refreshSession =
  (refreshToken: string): DashboardThunkAction =>
  async (dispatch, ...args): Promise<void> => {
    try {
      const { data, included, meta } = await SessionClientOnboard.postResourceSingletonAction<
        UserSession,
        { type: ApiModel.UserSession },
        CurrentUserSessionMeta
      >({ type: ApiModel.UserSession }, 'refresh', {
        meta: { 'refresh-token': refreshToken },
        ignoreAccessToken: true,
      });

      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      const user = included.find(({ id }) => id === data.relationships.user.data.id) as User;
      const roleIds = user.relationships.roles.data.map((roleData) => roleData.id);

      // Route Dashboard API requests to servers based off country from backend for current session
      SessionClientDashboard.personaCountry = SessionClientOnboard.personaCountry;
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      await fetchDashboardData({
        ...meta,
        user: user,
        userSession: data,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        roles: included.filter(({ id }) => roleIds.includes(id)) as Role[],
      })(dispatch, ...args);
    } catch (err) {
      await expireSession()(dispatch, ...args);
      throw err;
    }
  };

/**
 * This saga handles all cleanup logic associated with signing out
 */
export const expireSession =
  (): DashboardThunkAction =>
  async (dispatch, getState): Promise<void> => {
    const currentSession = getState().currentUserSession.userSession;

    if (currentSession != null) {
      try {
        await SessionClientDashboard.postResourceAction<UserSession>(
          { id: currentSession.id, type: currentSession.type },
          'expire',
        );
      } catch {
        // do nothing -- we don't really care if this fails
      }
    }

    // 1. Clear tokens
    // 2. Clear Redux state
    SessionClientDashboard.clearTokens();

    dispatch(resetState());
  };
